import { BlastEvent, SimulationConfig } from '../../../types';
import { drawBlastShape } from '../../../break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const RippleWaveAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  for (let i = 0; i < 4; i++) {
    const p = (progress + i * 0.2) % 1;
    ctx.globalAlpha = (1 - p);
    drawBlastShape(ctx, e, e.maxRadius + p * 150);
    ctx.stroke();
  }
};

registerBlastAnimation('RIPPLE_WAVE', RippleWaveAnimation);
